/// <reference path="../../../../typings/tsd.d.ts" />
module warsApp.models {
    export class ReviewConfigurationModel {
        public reviews: Wars.Domain.Model.Reviews.ReviewConfiguration[];
        public currentReviewConfiguration: Wars.Domain.Model.Reviews.ReviewConfiguration = null;
        public forms: Wars.Domain.Model.Form[];
        public claims: Wars.Domain.Model.ClaimDefinition[];
        public emails: Wars.Domain.Model.EmailConfiguration[];
        public userRepositories: string[];
        public reviewGroups: Wars.Domain.Model.Reviews.ReviewGroup[];
        public systemReviewGroup: Wars.Domain.Model.Reviews.ReviewGroup;
        public codeGroups: Wars.Domain.Model.Codes.CodeGroup[];

        public constructor(
            private reviewConfigurationService: services.ReviewConfigurationService,
            private formService: services.FormService,
            private claimDefinitionService: services.ClaimDefinitionService,
            private emailService: services.EmailConfigurationService,
            private securityMatrixService: services.SecurityMatrixService,
            private deleteService: services.DeleteService,
            private systemLevelService: services.SystemLevelService,
            private manageSystemCodesService: services.ManageSystemCodesService,
            private processConfigurationId?: string) {
            var self = this;

            if (processConfigurationId) {
                this.formService.getProcessConfigurationForms(processConfigurationId).then(forms => {
                    self.forms = forms;
                });

                this.claimDefinitionService.getAllProcessClaims(processConfigurationId).then(claims => {
                    self.claims = claims;
                });

                this.emailService.getAllEmailConfigurationsByProcessId(processConfigurationId).then(emails => {
                    self.emails = emails;
                    this.systemLevelService.getSystemEmailConfigurations().then(system => {
                        self.emails.addRange(system.myEmailConfigurations);
                    });
                });
            }

            this.reviewConfigurationService.getExtensibleUserRepositories().then(tags => {
                self.userRepositories = tags;
            });

            this.reviewConfigurationService.getReviewConfigurations(processConfigurationId).then(r => {
                self.reviews = r;
            });

            this.loadAllSystemCodes();

            this.systemLevelService.getSystemLevelReviewGroups().then(
                (systemLevel) => {
                    this.reviewGroups = systemLevel.myReviewGroups;
                });
        }

        private loadAllSystemCodes(): void {
            this.systemLevelService.getSystemLevelCodes().then(
                (systemLevel) => {
                    this.codeGroups = systemLevel.myCodeGroups;
                    if (this.processConfigurationId) {
                        this.manageSystemCodesService.getAllCodesForProcessConfiguration(this.processConfigurationId).then(
                            (codeGroups) => {
                                this.codeGroups = this.codeGroups.concat(codeGroups);
                            });
                    }
                });
        }

        public editReview(review: Wars.Domain.Model.Reviews.ReviewConfiguration): void {
            this.currentReviewConfiguration = review;
            this.systemReviewGroup = review.systemReviewGroup;
        }

        public systemReviewGroupChanged(): void {
            if (this.systemReviewGroup != null) {
                this.currentReviewConfiguration.systemReviewGroup = this.systemReviewGroup;
                this.currentReviewConfiguration.systemReviewGroup_id = this.systemReviewGroup.id;
                this.currentReviewConfiguration.codeGroup_id = this.systemReviewGroup.codeGroup_id;
            } else {
                this.currentReviewConfiguration.systemReviewGroup = undefined;
                this.currentReviewConfiguration.systemReviewGroup_id = undefined;
                this.currentReviewConfiguration.codeGroup_id = undefined;
            }
            this.save();
        }

        public addReview() {
            this.currentReviewConfiguration = this.reviewConfigurationService.createReviewConfiguration();

            this.currentReviewConfiguration.reviewLabel = "Review";
            this.currentReviewConfiguration.reviewerLabel = "Reviewer";
            this.currentReviewConfiguration.allowThreadedComments = false;
            this.currentReviewConfiguration.automaticallyClose = false;
            this.currentReviewConfiguration.allowCommentsOnReview = true;
            this.currentReviewConfiguration.allowAttachements = true;
            this.currentReviewConfiguration.name = "New Review";
            this.currentReviewConfiguration.closingType = Wars.Domain.Model.Codes.Enums.ClosingType.None;
            this.currentReviewConfiguration.processConfiguration_id = this.processConfigurationId;
            this.currentReviewConfiguration.allowAssignDateSelection = false;
            this.currentReviewConfiguration.endAssignDateType = Wars.Domain.Model.Codes.Enums.DateRange.AnyDate;
            this.currentReviewConfiguration.beginAssignDateType = Wars.Domain.Model.Codes.Enums.DateRange.AnyDate;

            this.currentReviewConfiguration.securityMatrix = this.securityMatrixService.createSecurityMatrix(false);

            this.currentReviewConfiguration.canRemoveSecurityMatrix= this.securityMatrixService.createSecurityMatrix(false);

            this.currentReviewConfiguration.commentThreadConfiguration = this.formService.createCommentThreadConfiguration();

            this.reviews.push(this.currentReviewConfiguration);
            this.save();
        }

        public delete(review: Wars.Domain.Model.Reviews.ReviewConfiguration): void {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "ReviewConfiguration",
                review.id,
                "Review successfully deleted",
                () => {
                    this.reviews.remove(review);
                    this.currentReviewConfiguration = undefined;
                },
                "Review could not be deleted");
        }

        public removeOption(code: Wars.Domain.Model.Codes.SystemCode) {
            code.entityAspect.setDeleted();
            //var index = Enumerable.from(this.field.fieldCodeGroup[0].codes).indexOf(c => c.id == code.id);
            //this.field.fieldCodeGroup[0].codes.splice(index, 1);
        }

        public addReminder() {
            let newReminder = this.reviewConfigurationService.createReviewReminder();
            newReminder.name = "New Reminder";
            newReminder.days = 1;
            newReminder.reviewConfiguration = this.currentReviewConfiguration;

            this.currentReviewConfiguration.reviewReminders.push(newReminder);
            this.save();
        }

        public manageSecurityMatrix() {
            this.securityMatrixService.openSecurityMatrixModal(this.currentReviewConfiguration.securityMatrix, this.processConfigurationId);
        }

        public manageRemovalSecurityMatrix() {
            if (!this.currentReviewConfiguration.canRemoveSecurityMatrix) {
                this.currentReviewConfiguration.canRemoveSecurityMatrix = this.securityMatrixService.createSecurityMatrix(false);
            }
            this.securityMatrixService.openSecurityMatrixModal(this.currentReviewConfiguration.canRemoveSecurityMatrix, this.processConfigurationId);
        }

        public removeReminder(reminder: Wars.Domain.Model.Reviews.ReviewReminder) {
            reminder.entityAspect.setDeleted();
            this.save();
        }

        public save() {
            this.reviewConfigurationService.saveAllChanges();
        }
    }
}